import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import apiGateWay from "../../serviceHandler";
import "./checkSummery.css";
import Loader from "../Common/Loader";


const Index = () => {
    const navigate = useNavigate();

    const tableData = (() => {
        try {
            return JSON.parse(sessionStorage.getItem("urlParams"));
        } catch (e) {
            return null;
        }
    })();

    const [openChecks, setOpenChecks] = useState([]);
    const [selectedCheck, setSelectedCheck] = useState(null);
    const [checkDetails, setCheckDetails] = useState(null);
    const [loadingItems, setLoadingItems] = useState([]);
    const [toasterData, setToasterData] = useState({});
    const [step, setStep] = useState("list"); // list | details

    useEffect(() => {
        fetchOpenChecks();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleLoader = (items, action) => {
        if (action === "add") {
            setLoadingItems((prev) => [...prev, ...items]);
        } else {
            setLoadingItems((prev) => prev.filter((it) => !items.includes(it)));
        }
    };

    const showToast = (type, message) => {
        setToasterData({ type, message });
        setTimeout(() => setToasterData({}), 4000);
    };

    // Fetch open checks
    const fetchOpenChecks = async () => {
        try {
            handleLoader(["openChecks"], "add");
            let res;
            const rvcForFallback = tableData?.rvc ?? "";
            const zone = tableData?.zone ?? "";
            const tableNumer = tableData?.actualTableNumber?.toString();
            res = await apiGateWay.get(
                `/keyconnect/simphony/GetOpenChecks?RevenueCenterObjectNum=${rvcForFallback}&Zone=${zone}&tableNumer=${tableNumer}`
            );

            handleLoader(["openChecks"], "remove");

            if (res?.status === 200) {
                const list = res?.data?.result ?? res?.data ?? [];
                if (!Array.isArray(list) || list.length === 0) {
                    setOpenChecks([]);
                    showToast("info", "No open checks found for this table.");
                } else {
                    setOpenChecks(list?.filter((item) => (tableNumer == item?.tableNumber)));
                }
            } else {
                showToast("error", "Failed to fetch open checks.");
            }
        } catch (err) {
            handleLoader(["openChecks"], "remove");
            console.error("fetchOpenChecks error", err);
            showToast("error", "Error fetching open checks.");
        }
    };

    // Fetch check details
    const fetchCheckDetails = async (check) => {
        if (!check) return;
        setSelectedCheck(check);

        const LocationId =
            tableData?.LocationId ?? tableData?.tableNumer ?? tableData?.LocationID ?? "";
        const RevenueCenterObjectNum =
            tableData?.rvc ??
            tableData?.RevenueCenterObjectNum ??
            check?.rvcCode ??
            "";
        const CheckNumber =
            check?.checkNumber ??
            check?.CheckNumber ??
            check?.checkNo ??
            check?.CheckNo;
        const CheckSequenceNumber =
            check?.checkSequenceNumber ??
            check?.CheckSequenceNumber ??
            check?.checkSequence ??
            check?.CheckSequence;

        if (!CheckNumber || !CheckSequenceNumber) {
            showToast("error", "Selected check doesn't have CheckNumber/CheckSequenceNumber.");
            return;
        }

        try {
            handleLoader(["checkDetails"], "add");
            const qs = new URLSearchParams({
                LocationId: String(LocationId || ""),
                RevenueCenterObjectNum: String(RevenueCenterObjectNum || ""),
                CheckNumber: String(CheckNumber),
                CheckSequenceNumber: String(CheckSequenceNumber),
            }).toString();

            const res = await apiGateWay.get(
                `/keyconnect/simphony/GetCheckDetails?${qs}`
            );
            handleLoader(["checkDetails"], "remove");

            if (res?.status === 200) {
                setCheckDetails(res?.data?.result ?? {});
                setStep("details");
                // showToast("success", "Loaded check details.");
            } else {
                showToast("error", "Failed to fetch check details.");
            }
        } catch (err) {
            handleLoader(["checkDetails"], "remove");
            console.error("fetchCheckDetails error", err);
            showToast("error", "Error fetching check details.");
        }
    };

    // Navigate to payment page
    const goToPayment = () => {
        setStep("pay");
        // const data = checkDetails?.checkSummary;
        // navigate("/ezmenu/payment", {
        // navigate("/payment", {
        //     state: {
        //         amount: data?.totalDue ?? 0,
        //         currency: "SAR",
        //     },
        // });
    };

    // Render open check list
    const renderList = () => (
        <div className="checks-wrapper">
            <h3 className="checks-title">order details</h3>
            {openChecks.length === 0 ? (
                <div style={{ textAlign: "center" }}>
                    <span className="inline-loader" role="status" aria-live="polite" aria-label="Loading">
                        <span className="visually-hidden">Loading...</span>
                    </span>
                </div>
            ) : (
                <>
                    <div className="checks-list">
                        {openChecks.map((c, idx) => {
                            const checkNumber =
                                c.checkNumber ?? c.CheckNumber ?? c.checkNo ?? c.CheckNo ?? "-";
                            const checkName = c.checkName ?? c.CheckName ?? c.Name ?? "-";
                            const checkTotal =
                                c.totalDue ?? c.CheckTotal ?? c.Amount ?? c.amount ?? "-";
                            const seq = c.checkSequenceNumber ?? c.CheckSequenceNumber ?? "-";

                            return (
                                <article className="check-card" key={idx}>
                                    <div className="card-title">
                                        Bill No. : <strong>{checkNumber}</strong>
                                    </div>

                                    {/* <div className="card-name">Name : {checkName}</div> */}

                                    <div className="card-bottom">
                                        <div className="total">
                                            {/* <div className="total-label">Total</div> */}
                                            <div className="card-title">Total :<strong>{checkTotal}</strong></div>
                                        </div>

                                        <div className="action">
                                            <button
                                                type="button"
                                                className="checks-btn"
                                                onClick={() => fetchCheckDetails(c)}
                                            >
                                                View Details
                                            </button>
                                        </div>
                                    </div>
                                </article>
                            );
                        })}
                    </div>

                    <div className="checks-button-wrap">
                        <button
                            className="checks-btn-secondary"
                            onClick={() => fetchOpenChecks()}
                        >
                            Refresh
                        </button>
                        <button className="checks-btn-secondary" onClick={() => navigate("/home")}>
                            Go Back
                        </button>
                    </div>
                </>
            )}
        </div>
    );

    // Render check details summary
    const renderDetails = () => {
        if (!checkDetails) return <div>Loading details...</div>;

        const data = checkDetails?.checkSummary ?? {};
        const summary = {
            checkName: data?.checkName ?? selectedCheck?.checkName ?? "-",
            checkNumber: data?.checkNumber ?? selectedCheck?.checkNumber ?? "-",
            checkSequenceNumber:
                data?.checkSequenceNumber ?? selectedCheck?.checkSequenceNumber ?? "-",
            checkTotal:
                data?.totalDue ??
                selectedCheck?.checkTotal ??
                checkDetails?.totalDue ??
                checkDetails?.Amount ??
                0,
            // guestCount: data?.guestCount ?? data?.guest_count ?? 0,
            guestCount: 1,
            tableNumber:
                data?.tableNumber ?? selectedCheck?.tableNumber ?? tableData?.tableNumer ?? "-",
            checkDate: data?.checkDate ?? selectedCheck?.checkDate ?? checkDetails?.createdAt ?? new Date().toISOString(),
        };

        // small helpers
        const fmtCurrency = (v) => {
            const n = Number(v ?? 0);
            if (Number.isNaN(n)) return v;
            return n.toFixed(2);
        };

        // try to parse and present a friendly date/time
        let formattedDate = summary.checkDate;
        try {
            const d = new Date(summary.checkDate);
            if (!Number.isNaN(d.getTime())) formattedDate = d.toLocaleString();
        } catch (e) {
            /* leave original */
        }

        return (
            <div className="checks-wrapper">
                <h3 className="checks-title">Order Details</h3>
                <div className="checks-details-wrapper">
                    <div className="bill-card">
                        <header className="bill-header">
                            <div className="bill-left">
                                <div className="bill-label">Bill No. :</div>
                                <div className="bill-value">{summary.checkNumber}</div>
                            </div>
                            <div className="bill-right">
                                <div className="bill-label">Date :</div>
                                <div className="bill-value">{formattedDate}</div>
                            </div>
                        </header>

                        {/* Items rendered as simple rows (no table) */}
                        <div className="bill-items">
                            <div className="bill-row" >
                                <div className="item-names">{"Item"}</div>
                                <div className="item-qty">{"Quantity"}</div>
                                <div className="item-qty">{"Price"}</div>
                            </div>
                            <div className="bill-sep" />
                            {Array.isArray(checkDetails?.menuItems) && checkDetails.menuItems.length > 0 ? (
                                checkDetails.menuItems.map((item, i) => (
                                    <div className="bill-row" key={i}>
                                        <div className="item-name">{item.name ?? item.itemName ?? "-"}</div>
                                        <div className="item-name">{item.quantity ?? item.qty ?? 1}</div>
                                        <div className="item-price">{fmtCurrency(item.price ?? item.rate ?? 0)}</div>
                                    </div>
                                ))
                            ) : (
                                <div className="bill-empty">No items</div>
                            )}
                        </div>

                        <div className="bill-sep" />

                        <div className="bill-total-row">
                            <div className="total-label">Total</div>
                            <div className="total-amount">{fmtCurrency(summary.checkTotal)}</div>
                        </div>

                        <div className="checks-details-buttons">
                            <button
                                type="button"
                                className="checks-btn-secondary"
                                onClick={() => {
                                    setStep("list");
                                    setCheckDetails(null);
                                }}
                            >
                                Back
                            </button>

                            <button type="button" className="checks-btn-success" onClick={goToPayment}>
                                Pay
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const renderPay = () => (
        <div className="checks-wrapper">
            <h3 className="checks-title">Coming Soon…</h3>
            <div style={{ textAlign: "center" }}>
                {/* <span className="inline-loader" role="status" aria-live="polite" aria-label="Loading"> */}
                <span >This page is in progress and will be available shortly.</span>
                {/* </span> */}
            </div>
        </div>
    );


    return (
        <div className="checks-page">
            <div
                id="snackbar"
                className={`checks-toast ${toasterData.type || ""} ${toasterData.type ? "show" : ""}`}
            >
                <span>{toasterData.message}</span>
            </div>

            <div className="checks-container">
                <img src="/images/Wild-Wadi-Logo_white.png" alt="EZmenu" className="checks-logo" />

                {step === "list" && renderList()}
                {step === "details" && renderDetails()}
                {step === "pay" && renderPay()}
            </div>
        </div>
    );
};

export default Index;
